import QuestionVideoTag from './QuestionVideoTag.component';

export default QuestionVideoTag;